export default __webpack_public_path__ + "static/media/cph_30256235761.5cdc0dde.jpg";